import React from "react";
import { useTranslation } from "react-i18next";

import underlineimage from "../assets/images/title-shape.png";
import phoneImage from "../assets/images/Esportsec/EsportsRoundImgs/gamingprofile.png";
import frnbbg from "../assets/images/Esportsec/esportsgamingprofile.png";

const GamingStats: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative pt-16 px-4 overflow-hidden bg-[#070b28] pb-[100px] bg-no-repeat bg-contain bg-bottom"
      style={{ backgroundImage: `url(${frnbbg})` }}
    >
      {/* Yellow Circle */}
      {/* <div className="absolute -top-20 -left-20 w-[170px] h-[170px] bg-[#ffc609] rounded-full z-10" /> */}

      {/* Title Section */}
      <div className="text-center relative z-20">
        <h2 className="text-[48px] font-oswald font-extrabold text-white">
          Gaming Profile
        </h2>
        <img
          src={underlineimage}
          alt="underline"
          className="mx-auto mt-2 mb-6 w-[120px] h-auto"
        />
        <p className="text-[16px] leading-[22px] text-white/80 font-proxima max-w-2xl mx-auto mb-0">
          {t("gamingStats.description")}
        </p>
      </div>

      {/* Two Column Section */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-20 px-4 md:px-12 relative z-20">
        {/* LEFT: Discover Section */}
        <div className="text-left max-w-md">
          <h3 className="text-[46px] font-bold text-[#ffc609] mb-[15px] font-proxima">
            {t("gamingStats.discover")}
          </h3>
          <p className="text-[20px] leading-[30px] font-semibold text-white mb-[15px] font-proxima">
            {t("gamingStats.discoverText")}
          </p>

          {/* <a
            href="https://play.google.com/store/apps/details?id=com.gamerji.sportsdraft"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20 w-[50%]"
          >
            <i className="fa fa-android fa-2x text-white mr-[2px]"></i>
            <div className="text-left leading-none">
              <p className="text-xs font-medium">{t("gamingStats.download")}</p>
              <p className="text-base font-bold">{t("gamingStats.androidApp")}</p>
            </div>
          </a> */}
        </div>

        {/* RIGHT: Phone Image */}
        <div>
          <img
            src={phoneImage}
            alt="Phone Stats"
            className="max-w-[300px] md:max-w-[360px] h-auto relative"
          />
        </div>
      </div>
    </div>
  );
};

export default GamingStats;
